<template>
  <div class="input-group">
    <select class="custom-select" v-model="hour" @change="changeHandler">
      <option v-for="(l, i) in hours" :key="i" :value="l">
        {{ l | ps }}
      </option>
    </select>
    <select class="custom-select" v-model="minute" @change="changeHandler">
      <option v-for="(l, i) in minutes" :key="i" :value="l">
        {{ l | ps }}
      </option>
    </select>
  </div>
</template>
<script>
import _ from "lodash";

function ps(val) {
  return _.padStart(val, 2, "0");
}

export default {
  components: {
    //
  },

  // directives
  filters: {
    ps
  },

  props: {
    value: {}
  },

  data: () => ({
    hours: Array.from(Array(24)).map((x, h) => h),
    minutes: [0, 15, 30, 45],
    hour: 0,
    minute: 0
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    reset() {
      this.minute = 0;
      this.hour = 0;
    },
    changeHandler() {
      this.$emit("input", this.getValueFormatted());
    },
    getValue() {
      return JSON.parse(JSON.stringify(this.$data));
    },
    getValueFormatted() {
      return `${ps(this.hour)}:${ps(this.minute)}`;
    }
  }
};
</script>

<style scoped></style>
